import React from 'react'
import advertisement_1 from '../images/advertisement_1'

export default function Advertisements() {

  return <>
   <div class="page-wrapper sec-mar">
        <article
          id="post-15"
          class="post-15 page type-page status-publish hentry"
        >
          <div class="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="15"
              class="elementor elementor-15"
            >
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-7570cb6 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                data-id="7570cb6"
                data-element_type="section"
              >
                <div class="elementor-container elementor-column-gap-no">
                  <div
                    class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0751275"
                    data-id="0751275"
                    data-element_type="column"
                  >
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-96da640 elementor-widget elementor-widget-spinner_slider"
                        data-id="96da640"
                        data-element_type="widget"
                        data-widget_type="spinner_slider.default"
                      >
                        <div class="elementor-widget-container">
                          <script></script>

                          <div class="banner-section2">
                            <div class="banner2-spring1"></div>
                            <div class="banner2-spring2"></div>
                            <div class="banner2-circle1"></div>
                            <div class="banner2-circle2"></div>
                            {/* <img
                              decoding="async"
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-vector.png"
                              class="banner2-vector"
                              alt="image"
                            /> */}

                            
                            <div class="swiper banner2">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  <img
                                    decoding="async"
                                    // src="https://p.kindpng.com/picc/s/219-2197314_advertise-with-us-advertisement-definition-hd-png-download.png"
                                    src={advertisement_1}
                                    // src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/Banner-Image.jpg"
                                    class="slider-bg"
                                    alt="image"
                                  />
                                  <div class="container">
                                    <div class="row d-flex justify-content-center align-items-center">
                                      <div class="col-xl-7 col-lg-10">
                                        <div class="banner2-content">
                                          <span>
                                            WE ARE TOP NOTCH MEDIA WORKS
                                          </span>
                                          <h2>Advertisements
</h2>

                                         
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  <img
                                    decoding="async"
                                    src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-bg2-1.png"
                                    class="slider-bg"
                                    alt="image"
                                  />
                                  
                                </div> */}
                              </div>
                            </div>
                            <div class="banner2-pagination d-flex justify-content-center flex-row align-items-center gap-2"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>

       {/* main section */}

<div className="container">
  <div className="row text-center">
    <h1><b>Advertisements


</b></h1>
<p>Advertising is a means of communincation with the users of a product of service



</p>
  </div>
</div>


<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Radio Advertisement
-</span>
                    <h3 className="text-white">
                    Radio Advertisement
                    </h3>
                    <p class="para mb-0 ">
                    Radio advertisements are called spots, and businesses are buying these to promote their brand. Radio advertising is further subdivided into three types – live read, sponsorship, or produced spot.
                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://www.strategicmediainc.com/wp-content/uploads/2020/06/iStock-1071759456.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


{/* /target Analysis */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://www.exchange4media.com/news-photo/99827.HDchannel.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-T.V Advertisements



-</span>
                    <h3  className="text-white">
                    T.V Advertisements




                    </h3>
                    <p class="para mb-0 ">
                    The target event property returns the element that triggered the event. The target property gets the element on which the event originally occurred, opposed to the currentTarget property,



.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* POC Creation */}

      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Event Target


-</span>
                    <h3  className="text-white">
                    Event Target
                    </h3>
                    <p class="para mb-0 ">
                    The target event property returns the element that triggered the event. The target property gets the element on which the event originally occurred, opposed to the currentTarget property,


                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11 mt-5">
                       
                        </div>
                     
                        <img src="https://media.istockphoto.com/id/1324561072/photo/party-people-enjoy-concert-at-festival-summer-music-festival.jpg?b=1&s=170667a&w=0&k=20&c=O5ZV-dsb8hWNxQMWyFa8bVwnebURDCbq29Ktw3DxJr0=" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://www.businessapac.com/wp-content/uploads/2022/03/AD-Campaigns-Featured-Image.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Campaigns


-</span>
                    <h3  className="text-white">
                    Campaigns




                    </h3>
                    <p class="para mb-0 ">
                    Marketing campaigns are organized, strategized efforts to promote a specific company goal, such as raising awareness of a new product or capturing customer feedback.


.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="container">
        <div className="row text-center">
          <h1><b>Our Team For You</b></h1>
          <ul class="para mb-0 ">
            <li> 1. Well experienced.</li>
            <li> 2. AdWords and Bing Certified.</li>
            <li> 3. Works with perfect plan & full Transparency for better outcome.</li>
            <li> 4. Have proven track record of work and achievements.</li>
          </ul>
          <br />
          <br />
          <p class="para mb-0 ">
           
We also use business goals to customize the pay per click advertisement campaigns on Google AdWords.
Best in targeting is filter data and using it for best setup of any campaign for example:- Negative keywords or labelling of group performing keywords is used
according to the business with which you can filter after running PPC campaigns and generate more ROI in less budget.</p>
        </div>
      </div> */}

  </>
}
